import { create } from "zustand";

const useInterviewConversationStore = create((set, get) => ({
    // Message history: {id, sender: 'USER'|'AI', content, timestamp}
    messages: [],
    
    // Track input source: 'text' | 'voice' | null
    inputSource: null,
    
    // Add a new message to history
    addMessage: (sender, content) => {
        if (!content || !content.trim()) return;
        
        const newMessage = {
            id: Date.now(),
            sender,
            content: content.trim(),
            timestamp: new Date().toISOString()
        };
        
        set((state) => ({
            messages: [...state.messages, newMessage]
        }));
    },
    
    // Clear all messages
    clearMessages: () => set({ messages: [] }),
    
    // Set input source (text/voice/null)
    setInputSource: (source) => set({ inputSource: source }),
    
    // Get all messages
    getMessages: () => get().messages,
}));

export default useInterviewConversationStore;
